import { GroupBase, OptionProps, components } from "react-select";

import { RoomSystemOption } from "@/features/session/types/room-system-option";

export function RoomSystemSelectOption(
  props: OptionProps<RoomSystemOption, boolean, GroupBase<RoomSystemOption>>,
) {
  const roomSystem = props.data;

  return (
    <components.Option {...props}>
      <div className="flex items-center">
        <div className="ml-2">
          <p>{roomSystem.name}</p>
          <p className="text-sm text-muted-foreground">
            {roomSystem.organisationName}
          </p>
        </div>
      </div>
    </components.Option>
  );
}
